export default {
    'name': 'telegram-footer',
    'width': '32',
    'height': '32',
    'viewBox': '0 0 32 32',
    'data': '<rect width=\'32\' height=\'32\' rx=\'16\' fill=\'white\'/><path d=\'M22.4 10.0818L19.9956 22.6338C19.9956 22.6338 19.6592 23.5041 18.7351 23.0867L13.1876 18.682L13.1619 18.6691C13.9112 17.9723 19.7219 12.5621 19.9758 12.3169C20.369 11.9371 20.1249 11.711 19.6684 11.9979L11.0854 17.6424L7.77406 16.4886C7.77406 16.4886 7.25296 16.2966 7.20283 15.8793C7.15203 15.4612 7.79121 15.2351 7.79121 15.2351L21.2905 9.75113C21.2905 9.75113 22.4 9.24632 22.4 10.0818Z\' fill=\'#0158CE\'/>'
}
